interface AlarmReceivedProps {
  alarm: any;
  unitName: string | null;
  unitStatus: string;
  onStatusChange: (status: string) => void;
  onEnroute: () => void;
}

export default function AlarmReceived({
  alarm,
  unitName,
  unitStatus,
  onStatusChange,
  onEnroute,
}: AlarmReceivedProps) {
  if (!alarm) {
    return <div>Loading alarm...</div>;
  }

  const alarmCode = String(alarm.einsatzcode || '').trim();
  const alarmLabel = String(alarm.einsatzcodeLabel || '').trim();
  const alarmCodeSizeClass =
    alarmCode.length > 26
      ? 'text-3xl sm:text-4xl md:text-5xl'
      : alarmCode.length > 18
        ? 'text-4xl sm:text-5xl md:text-6xl'
        : 'text-6xl sm:text-7xl md:text-8xl';

  const priorityColors: any = {
    ALPHA: 'bg-priority-alpha',
    BRAVO: 'bg-priority-bravo',
    CHARLIE: 'bg-priority-charlie',
    DELTA: 'bg-priority-delta',
  };

  const getPriorityColor = () => {
    const code = alarm.einsatzcode;
    if (code.includes('D')) return priorityColors.DELTA;
    if (code.includes('C')) return priorityColors.CHARLIE;
    if (code.includes('B')) return priorityColors.BRAVO;
    return priorityColors.ALPHA;
  };

  return (
    <div
      className={`min-h-screen ${getPriorityColor()} safe-screen flex flex-col items-center justify-start p-4 py-6 space-y-6 relative overflow-x-hidden overflow-y-auto`}
    >
      {/* Animated background pulse */}
      <div className="absolute inset-0 animate-pulse opacity-20"></div>

      <div className="relative z-10 text-center space-y-6 w-full max-w-2xl pb-8">
        <div className="text-8xl animate-bounce">🚨</div>

        <div className="space-y-3 rounded-2xl bg-black/25 px-4 py-5 backdrop-blur-sm">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-white/80">Einsatzcode</p>
          <h1
            className={`font-alarm-code ${alarmCodeSizeClass} leading-[0.95] font-bold text-white drop-shadow-lg break-words [overflow-wrap:anywhere]`}
          >
            {alarmCode || '-'}
          </h1>

          {alarmLabel && (
            <p className="text-xl sm:text-2xl md:text-3xl font-semibold leading-tight text-white/95 drop-shadow [overflow-wrap:anywhere]">
              {alarmLabel}
            </p>
          )}
        </div>

        <div className="bg-black bg-opacity-60 p-6 rounded-lg backdrop-blur">
          <h2 className="font-alarm-address font-bold text-white mb-2">{alarm.location.address}</h2>
          <p className="text-lg text-gray-200">{alarm.location.gemeinde}</p>
        </div>

        <div className="space-y-3 w-full">
          <button
            onClick={() => {
              onStatusChange('responding');
              setTimeout(onEnroute, 500);
            }}
            className="w-full bg-white hover:bg-gray-100 text-black font-bold py-4 px-6 rounded-lg text-lg transition shadow-lg"
          >
            ✓ ANNAHME & AUSFAHRT
          </button>
        </div>

      </div>
    </div>
  );
}
